"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.pushNavigateMessage = pushNavigateMessage;
exports.pushActivateMessage = pushActivateMessage;
exports.getNavigationChannelName = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _BuildConstants = require("../../../utils/BuildConstants");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _MessagingService = _interopRequireDefault(require("../MessagingService"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../../common/NavigationManagerCordova"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _KESI2Helper = require("../../KESI2Helper");

/**
 * Created by falknisius on 15.06.17.
 */
// const NAVIGATION_CHANNEL = `${ABLY_CHANNEL_PREFIX}REMOTECONTROL`
// init channel
// messageService.getChannel(NAVIGATION_CHANNEL)
var getNavigationChannelName = function getNavigationChannelName() {
  return "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, ":REMOTECONTROL");
};
/**
 * build a message enhanced with the applicationInstanceId, and localTimestamp
 * send it immediatly
 *
 * @param id     - off the entered content element
 * @param path   - the path to the content element
 *
 * @param scrollPosition
 */


exports.getNavigationChannelName = getNavigationChannelName;

function pushNavigateMessage() {
  return _pushNavigateMessage.apply(this, arguments);
}

function _pushNavigateMessage() {
  _pushNavigateMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var id,
        path,
        scrollPosition,
        message,
        pathToSend,
        channel,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            path = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            scrollPosition = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            console.log('pushNavigateMessage', id, path);
            _context.t0 = window.screen.orientation.type.split('-')[0];
            _context.t1 = new Date().getTime();
            _context.next = 8;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 8:
            _context.t2 = _context.sent;
            message = {
              screenOrientation: _context.t0,
              deviceUTCTime: _context.t1,
              applicationInstanceId: _context.t2
            };

            if (id && path) {
              // if it is an array: join, if not use string
              pathToSend = path.join ? path.join('!') : path;
              message.id = id;
              message.path = "!".concat(pathToSend);
            }

            if (scrollPosition || scrollPosition === 0) {
              message.scrollPosition = scrollPosition;
            }

            console.log('send', _config["default"].sendNavigateMessages);

            if (!_config["default"].sendNavigateMessages) {
              _context.next = 18;
              break;
            }

            _context.next = 16;
            return _MessagingService["default"].getChannel(getNavigationChannelName(), false);

          case 16:
            channel = _context.sent;

            _MessagingService["default"].sendMessage(channel, 'navigateTo', message);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pushNavigateMessage.apply(this, arguments);
}

function pushActivateMessage(_x, _x2, _x3, _x4) {
  return _pushActivateMessage.apply(this, arguments);
}

function _pushActivateMessage() {
  _pushActivateMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(state, id, path, active) {
    var isNugget,
        message,
        channel,
        scrollTop,
        currentId,
        _args2 = arguments;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isNugget = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : true;
            _context2.t0 = state;
            _context2.t1 = new Date().getTime();
            _context2.next = 5;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 5:
            _context2.t2 = _context2.sent;
            message = {
              state: _context2.t0,
              deviceUTCTime: _context2.t1,
              applicationInstanceId: _context2.t2
            };
            _context2.next = 9;
            return _MessagingService["default"].getChannel(getNavigationChannelName(), false);

          case 9:
            channel = _context2.sent;

            _MessagingService["default"].sendMessage(channel, 'activate', message);

            if (!(active && isNugget && (0, _KESI2Helper.isRemoteControllingEnabled)())) {
              _context2.next = 17;
              break;
            }

            scrollTop = _NavigationManagerCordova["default"].getScrollTop();
            currentId = _NavigationManagerCordova["default"].getCurrentId();
            _context2.next = 16;
            return (0, _TimeoutHelper.timeout)(1000);

          case 16:
            pushNavigateMessage(currentId, path, scrollTop);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _pushActivateMessage.apply(this, arguments);
}